<template>
    <v-main>
        <div class="pt-3 pb-3 pr-3 pl-3 mb-6">
            <ChartTotalNotes />
        </div>
        <div class="pt-9 pb-9 pr-9 pl-9">
            <v-container>
                <v-row class="mb-9">
                    <Tabs
                        ref="tabEl"
                        @update="updateTab"
                        :tabs="tabs"
                        :allowUserChange="true"
                        :showCounter="false"
                    />
                </v-row>
                <OpenOutgoes
                    v-show="currentTab === 'lista'"
                    @onConfirmEligibles="onConfirmEligibles"
                />
                <div
                    class="d-flex justify-center"
                    v-if="openOutgoesListRequestStatus === RequestStatusEnum.START"
                >
                    <Loader class="text-center mt-3" />
                </div>

                <v-row class="mt-16" v-if="currentTab === 'lista'">
                    <Lista :outgoesFilterType="outgoesFilterType" />
                </v-row>
                <v-row class="mt-16" v-if="currentTab === 'acompanhamento'">
                    <FollowUp />
                </v-row>
                <v-row class="mt-16" v-if="currentTab === 'desembolsos'">
                    <Desembolsos :outgoesFilterType="outgoesFilterType" />
                </v-row>
            </v-container>
        </div>
        <Loader
            v-if="
                cancelOutgoRequestStatus === RequestStatusEnum.START ||
                sendOutgoRequestStatus === RequestStatusEnum.START
            "
            mode="overlay"
        />
    </v-main>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Tabs from '@/components/base/Tabs';
import FollowUp from './_FollowUp';
import Desembolsos from './_Desembolsos';
import Lista from './_Lista';
import OpenOutgoes from '../components/_OpenOutgoes';
import ChartTotalNotes from '../components/ChartTotalNotes';
import { RequestStatusEnum } from '@/helpers/consts';
import Loader from '@/components/base/Loader';
import { notification } from '@/helpers/notification';

export default {
    components: {
        Tabs,
        Lista,
        FollowUp,
        Desembolsos,
        ChartTotalNotes,
        Loader,
        OpenOutgoes,
    },
    data() {
        return {
            tabs: [
                {
                    name: this.$tc('gestao.tabs.titulos'),
                    path: 'lista',
                },
                {
                    name: this.$tc('gestao.tabs.followUp'),
                    path: 'acompanhamento',
                },
                {
                    name: this.$tc('gestao.tabs.outgoes'),
                    path: 'desembolsos',
                },
            ],
            currentTab: null,
            RequestStatusEnum,
            showAllOpenOutgoes: false,
        };
    },
    computed: {
        tabFromQuery() {
            return this.$router.history.current.params.step;
        },
        ...mapGetters('gestao', {
            cancelOutgoRequestStatus: 'cancelOutgoRequestStatus',
            sendOutgoRequestStatus: 'sendOutgoRequestStatus',
            removeOutgoRequestStatus: 'removeOutgoRequestStatus',
            selectedProduct: 'selectedProduct',
            openOutgoesListRequestStatus: 'openOutgoesListRequestStatus',
        }),
        outgoesFilterType() {
            return this.$route.meta.filters.tipo;
        },
    },
    mounted() {
        this.currentTab = this.tabFromQuery;
        const index = this.tabs.findIndex(tab => this.currentTab === tab.path);
        if (this.$refs.tabEl.toIndex) {
            this.$refs.tabEl.toIndex(index);
        }
        this.updateOpenOutgoes();
    },
    methods: {
        ...mapActions('gestao', {
            fetchOpenOutgoes: 'fetchOpenOutgoes',
            removeTitulosFromOutgo: 'removeTitulosFromOutgo',
        }),
        updateTab(item) {
            this.$refs.tabEl.updateTabRouting(this, item, '/admin/gestao/titulos');
        },

        updateOpenOutgoes() {
            this.fetchOpenOutgoes({
                idProduct: this.selectedProduct.id,
                status: '1,2',
                filters: { tipo: this.outgoesFilterType },
            });
        },
        onConfirmEligibles(outgoId, meta) {
            this.removeTitulosFromOutgo({
                idProduct: this.selectedProduct.id,
                outgoId,
                removedIds: meta.removedIds,
            });
        },
    },
    watch: {
        cancelOutgoRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                this.updateOpenOutgoes();
                notification(this.$dialog.notify.success, this.$tc('outgo.cancel.success'));
            }
            if (newValue.type === RequestStatusEnum.ERROR) {
                notification(
                    this.$dialog.notify.error,
                    this.$t('outgo.cancel.error', { msg: newValue.message })
                );
                return RequestStatusEnum.ERROR;
            }
        },
        sendOutgoRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                this.updateOpenOutgoes();
                notification(this.$dialog.notify.success, 'Desembolso enviado com sucesso');
            }
            if (newValue.type === RequestStatusEnum.ERROR) {
                notification(
                    this.$dialog.notify.error,
                    'Ocorreu um erro ao enviar o desembolso: ' + newValue.message
                );
                return RequestStatusEnum.ERROR;
            }
        },
        removeOutgoRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                this.updateOpenOutgoes();
                notification(this.$dialog.notify.success, 'Títulos removidos com sucesso');
            }
            if (newValue.type === RequestStatusEnum.ERROR) {
                notification(
                    this.$dialog.notify.error,
                    'Ocorreu um erro ao remover os títulos do desembolso: ' + newValue.message
                );
                return RequestStatusEnum.ERROR;
            }
        },
        openOutgoesListRequestStatus(newValue) {
            if (newValue.type === RequestStatusEnum.ERROR) {
                notification(
                    this.$dialog.notify.error,
                    'Ocorreu um erro ao listar os desembolsos em aberto: ' + newValue.message
                );
                return RequestStatusEnum.ERROR;
            }
        },
    },
};
</script>
